var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F767E",
    d: "M784.8,426.1c-113.2,0-205,91.8-205.1,204.9c-0.1,113.1,92,205.1,205.4,205.1c112.8,0,204.8-91.9,204.9-204.7C990.1,518.1,898.1,426.1,784.8,426.1z M920.3,566.3L758.6,729.8c-9.3,9.4-24.3,9.4-33.6,0l-75.6-76.3c-9.3-9.4-9.3-24.5,0-33.9c9.3-9.4,24.3-9.4,33.6,0l58.8,59.4l145-146.5c9.3-9.3,24.3-9.3,33.6,0C929.6,541.8,929.6,557,920.3,566.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F767E",
    d: "M536.1,522.4c0-12.2-9.9-22.2-22.2-22.2H307.5c-12.2,0-22.2,9.9-22.2,22.2c0,12.3,9.9,22.2,22.2,22.2h206.4C526.1,544.6,536.1,534.7,536.1,522.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.2,424.6c0-12.2-9.9-22.2-22.2-22.2H307.5c-12.2,0-22.2,9.9-22.2,22.2c0,12.2,9.9,22.2,22.2,22.2h270.6C590.3,446.8,600.2,436.8,600.2,424.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F767E",
    d: "M307.5,598.2c-12.2,0-22.2,9.9-22.2,22.2c0,12.2,9.9,22.2,22.2,22.2h119.8c12.3,0,23.6-9.9,23.6-22.2c0-12.3-9.9-22.2-22.2-22.2H307.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F767E",
    d: "M588.7,778.5H263.3c-21.6,0-39.2-17.6-39.2-39.3v-6.9v-59.6V366.5c0-21.7,17.6-39.3,39.2-39.3H636c21.6,0,39.2,17.6,39.2,39.3v57.4c18.5-7.5,38.3-12.6,58.8-14.9v-62.1c0-43.3-35.1-78.5-78.5-78.5h-76.8v-27.3c0-43.4-35.1-78.5-78.5-78.5H88.5c-43.3,0-78.5,35.1-78.5,78.5v412c0,43.4,35.1,78.5,78.5,78.5h76.8v27.3c0,43.4,35.1,78.5,78.5,78.5h423.4C636.8,823.7,610.1,803.5,588.7,778.5z M108.1,672.7c-21.6,0-39.2-17.6-39.2-39.2V260.7c0-21.7,17.6-39.3,39.2-39.3h372.6c21.6,0,39.2,17.6,39.2,39.3v7.7H243.7c-43.3,0-78.5,35.1-78.5,78.5v325.9H108.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/Activate.7675f519882d1832204088c161413e1c.svg";
export { ForwardRef as ReactComponent };